// Vendor
import $ from 'jquery'
import anime from 'animejs'

// Modules
import VHChromeFix from './components/mobile-chrome-vh-fix'
// import { navAffix } from './components/nav-affix'
// import Modal from './components/modal'
import Util from 'util'

const $html               = $('html')
const $body               = $('body')
const pageDuration        = 400
const pageEasing          = 'easeOutCubic'
const pageInClasses       = 'hidden fixed absolute--fill overflow-hidden shadow-2 z-200 in'
const pageOutClasses      = 'page bg-black overflow-hidden out'
const currentYear         = new Date().getFullYear()

let instance              = null

// App init
class App {

  constructor(config) {
    if (instance) instance = this

    this._req           = null
    this.maxDocHeight   = null
    this.sr             = null
    this.state          = {}
    this.$ajaxContainer = $(config.ajaxContainer)
    this.$videoLightbox = $('.video-lightbox')

    return instance
  }

  init() {

    $(document).ready(() => this._onDocReady())

    $body.on('click', 'a[href="#"]', (e) => e.preventDefault())

    $body.on('blur', '.input-with-label', (e) => this._toggleInputValue(e.currentTarget))

    this._initMenu()

    // Set the intial state of history to the first loaded page
    if (typeof(history.replaceState) !== "undefined") {
      history.replaceState({ url: "" + window.location.pathname + "" }, null, null)
    }

    // Browser doesn't support HTML 5 history
    if (history.pushState) this._initAjax()

    return this
  }

  _showLoader(cb) {
    const $loader = $('#ajax-loader')
    $loader.show()
    $loader.find('.loader').show()
    if (cb) cb()
  }

  _hideLoader(animate, cb) {
    const $loader = $('#ajax-loader')
    $loader.find('.loader').hide()
    if (animate) {
      const loaderAnime = anime({
        duration: pageDuration*2,
        targets: $loader[0],
        opacity: 0,
        easing: 'linear',
        complete: () => {
          $loader.hide().css('opacity', '')
          if (cb) cb()
        }
      })
    }
    else {
      $loader.hide()
      if (cb) cb()
    }
  }

  _onDocReady() {
    const $loader = $('#ajax-loader')
    const $page = $('.page.active')

    this._beforePageShow($page)

    this._hideLoader(true, () => {
      this._onPageShown($page)
      $loader.removeClass('z-9999')
    })

    this._VHChromeFix()

    this.maxDocHeight = Math.max($(document).height(), $(window).height())

    // Debugging without animation
    // $loader.hide()
    // $html.removeClass('loading')
    // this._onPageShown()

    this.state.appLoaded = true
  }

  /* ==========================================================================
     Menus
     ========================================================================== */

  _highlightMenuItem($target) {
    const sel = 'a[href="'+window.location.pathname+'"]'
    const $link = $target || $('.menu-item '+sel)

    $link.parent().addClass('active')
    $('.menu-item a').not($link).parent().removeClass('active')

    $('.sub-menu').each(function() {
      const active = $(this).has($link).length > 0

      $(this)
        .toggleClass('active expanded', active)
        .find('> a .caret')
        .toggleClass('rotate-90', active)
        .end()
        .find('> .sub')
        .toggleClass('dn', !active)
    })
  }

  _toggleSubMenu($sm, show, cb) {
    const { anim } = $sm[0]
    const duration = 400
    const menu = $sm.find('>.sub')[0]

    if (show && $sm.hasClass('expanded')) return

    $sm
      .toggleClass('expanded', show)
      .find('> a .caret').toggleClass('rotate-90', show)

    if (anim) anim.pause()

    const prog = anim && !anim.completed ? (anim.progress/100) : 1
    const h1 = menu.style.height || 0
    if (show) {
      menu.style.height = null
      menu.style.opacity = 0
    }
    const h2 = $(menu).show().outerHeight()

    $sm[0].anim = anime({
      targets: menu,
      opacity: {
        value: show ? 1 : 0,
        duration: duration * prog,
        easing: show ? 'easeInCirc' : 'easeOutCirc'
      },
      height: {
        value: show ? [h1,h2] : 0,
        duration: duration * prog,
        easing: 'easeOutCirc'
      },
      begin: () => $(menu).addClass('overflow-hidden'),
      complete: an => {
        if (!show) $(menu).hide()
        menu.style.height = null
        menu.style.opacity = null
        $(menu).removeClass('overflow-hidden')
        if (cb) cb()
      }
    })
  }

  _initMenu() {
    $body.on('keydown', '.sub-menu a', (e) => {
      let $sm = $(e.currentTarget).closest('.sub-menu')
      if (e.keyCode === 37) { // Left
        $sm = $(e.currentTarget).closest('.sub-menu.expanded')
        if (!$sm.length) return
        this._toggleSubMenu($sm, false, () => $sm.find('> a').focus())
      } else if (e.keyCode === 39) { this._toggleSubMenu($sm, true) } // Right
    })

    $body.on('click', '.sub-menu > a', (e) => {
      const $sm = $(e.currentTarget).parent()
      e.preventDefault()
      this._toggleSubMenu($sm, !$sm.hasClass('expanded'))
    })

    $body.on('click', '.menu-item a', (e) => this._highlightMenuItem($(e.currentTarget)))
  }

  /* ==========================================================================
     100vh alternative in JS
     ========================================================================== */

  _VHChromeFix() {
    // TODO: Add other tachyons classes
    const options = [{
      selector: '.min-vh-100-l',
      vh: 100,
      min: true
    }]

    this.vhFix = new VHChromeFix(options)
  }

  /* ==========================================================================
     Video lightbox
     ========================================================================== */

  _showVideoLightbox(ev, $page) {
    const url = $(ev.currentTarget).data('video')
    const aspectRatio = $(ev.currentTarget).data('aspect-ratio') || '235x1'
    const $lightbox = this.$videoLightbox

    if (!$lightbox.length) return

    ev.preventDefault()

    $lightbox.find('.aspect-ratio')
      .removeClass((index, className) => {
        return (className.match (/(^|\s)aspect-ratio--\S+/g) || []).join(' ')
      })
      .addClass(`aspect-ratio--${aspectRatio}`)
      .parent()
      .toggleClass('mw7-custom', aspectRatio === '4x3')
      .toggleClass('mw8-custom', aspectRatio === '16x9')
      .toggleClass('mw9', aspectRatio === '235x1')

    const $iframe = $lightbox.find('iframe')
    const showLightbox = anime({
      targets: $lightbox[0],
      opacity: 1,
      duration: 600,
      easing: 'easeOutCirc',
      autoplay: false,
      begin: () => {
        if ($iframe.attr('src') !== url) $iframe.attr('src', '')
        $lightbox.removeClass('dn')
      },
      complete: () => {
        if ($iframe.attr('src') !== url) $iframe.attr('src', url)
      }
    })

    function hideVideoLightbox(e) {
      showLightbox.pause()
      const hideLightbox = anime({
        targets: $lightbox[0],
        opacity: 0,
        duration: 400,
        easing: 'easeOutCirc',
        complete: () => {
          $lightbox.find('.loader').removeClass('dn')
          $lightbox.addClass('dn')
        }
      })
      e.preventDefault()
      // TODO: figure out how to fire alternative complete callback on reverse
      // showLightbox.reverse()
      // showLightbox.play()
      $body.removeClass('overflow-hidden')
      $lightbox.off('click, keydown')
      $(document).off('keydown.hide.video')
      $(ev.currentTarget).focus()
    }

    $body.addClass('overflow-hidden')
    $iframe[0].onload = () => $lightbox.find('.loader').addClass('dn')
    showLightbox.play()
    $(document).on('keydown.hide.video', (e) => {
      if (e.keyCode === 27) hideVideoLightbox(e)
    })
    $lightbox.on('click', (e) => {
      const $target = $(e.currentTarget)
      if ($target.is('.iframe-container') || $('.iframe-container').has($target).length) return
      hideVideoLightbox(e)
    })
  }

  _initVideoItems($page) {
    const $link = $page.find('[data-target="video"]')

    // Lightbox
    $link.on('click', (e) => this._showVideoLightbox(e, $page))

    // Hover effects
    function animateVideoThumb($item, enter) {
      const $title = $item.find('.video-title')
      const $thumb = $item.find('.video-thumb')
      const scaleThumb = enter ? 1.15 : 1
      const scaleTitle = enter ? 1.25 : 1
      const duration = enter ? 3500 : 700
      const easing = enter ? 'easeOutExpo' : 'easeInOutQuart'
      anime.remove($thumb[0])
      anime.remove($title[0])
      anime({
        targets: $title[0],
        scale: scaleTitle,
        opacity: enter ? 0 : 1,
        duration: enter ? duration * .5 : duration,
        easing: easing
      })
      anime({
        targets: $thumb[0],
        scale: scaleThumb,
        opacity: enter ? 1 : .9,
        duration: duration,
        easing: easing
      })
    }

    $link.each((i,l) => {
      const $item = $(l).closest('.video-item')
      if ($(l).length === 0) return
      $(l)
        .on('mouseenter', () => animateVideoThumb($item, true))
        .on('mouseleave', () => animateVideoThumb($item))
    })
  }

  /* ==========================================================================
     Newsletter form
     ========================================================================== */

  _initEmailForm($page) {
    const $email = $page.find('#mce-EMAIL')
    const $responses = $page.find('#mce-responses')
    const $error = $page.find('#mce-error-response')

    // Validate one @ symbol: https://stackoverflow.com/a/43996840/1712562
    function validateEmail(email) {
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
      return re.test(email)
    }

    function validate() {
      const email = $email.val()
      const validation = validateEmail(email)
      const response = email ? 'Invalid email address' : 'Email address required'
      $responses.toggleClass('hidden', validation)
      if (!validation) $error.text(response)
      return validation
    }

    if ($email.length) {
      $email.on('blur', () => {
        $email.off('keyup')
        if ($email.val() && !validate()) {
          $email.on('keyup', () => {
            if (validate() && $email.val()) $email.off('keyup')
          })
        }
        else {
          $responses.addClass('hidden')
        }
      })
      $page.find('#mc-embedded-subscribe-form').on('submit', (e) => {
        if (!validate()) e.preventDefault()
      })
    }
  }

  /* ==========================================================================
     Add class for ajax loading
     ========================================================================== */

  _ajaxLinkClass() {
    const siteURL = 'http://' + top.location.host.toString()
    const $anchorLinks = $(`a[href^="#"]`).not('a[href="#"]')
    const $navTopLinks = this.state.appLoaded ? null : $('#navTop .menu-item')

    // TODO: remove unused classes
    $('.page.active')
    .add($navTopLinks)
    .find('a[href^="' + window.location.origin + '"], a[href^="/"], #pagination a')
    .not('[download]')
    .each(function() {
      const link = $(this)

      if (!link.hasClass('rss')) {
        link.addClass('js-ajax-link')

        if (link.attr('href') == window.location.origin) {
          link.addClass('js-show-index')
        }
      }
    })

    // Smooth scrolling links
    $anchorLinks.on('click', e => {
      e.preventDefault()
      this._smoothScrollToElement(e.currentTarget.hash)
    })
  }

  _smoothScrollToElement(element) {
    const elementSelector = document.querySelector(element)
    const elementOffset = elementSelector.getBoundingClientRect().top
    const scrollPosition = window.scrollY
    const documentTop = document.documentElement.clientTop

    const scrollOffset = elementOffset + scrollPosition - documentTop

    anime({
      targets: [document.documentElement, document.body],
      scrollTop: scrollOffset,
      duration: 600,
      easing: 'easeOutCirc'
    })
  }

  /* ==========================================================================
     Ajax Loading
     ========================================================================== */

  _initAjax() {
    const that = this

    window.onpopstate = (e) => {
      const url = e.state && e.state.url
      this._pageRequest(url, true)
    }

    function followLink($link) {
      if (!that.state.loading) {
        const currentUrl = window.location.pathname
        const url = $link.attr('href')
        const title = $link.attr('title') || null

        if (url.replace(/\/$/, "") !== currentUrl.replace(/\/$/, "")) {
          that.state.loading = true
          that._pageRequest(url, null, title)
        }
        else {
          that._smoothScrollToElement(`#${that.$ajaxContainer.attr('id')}`)
        }
      }
    }

    $body.on('click', '.js-ajax-link', function(e) {
      e.preventDefault()
      followLink($(this))
    })
  }

  _pageRequest(url, pop, title) {
    const that = this
    const $oldRegion = this.$ajaxContainer.find('.page')
    const st = window.pageYOffset || document.documentElement.scrollTop
    const stNew = pop ? st : 0
    let delayShowLoader

    if (this._req) this._req.abort()

    function pageRequest() {
      that._req = $.get(url, (result) => {
          clearTimeout(delayShowLoader)
          that._showPage(result, pop, url, title)
        })
        .fail(() => {
          $.get('404.html', (result) => that._showPage(result, pop, url, title))
        })
    }

    this.$ajaxContainer.addClass('overflow-hidden')
    $html.addClass('loading')
    // navAffix.disable()

    // Show loader after a delay for a smoother UX on faster connections
    clearTimeout(delayShowLoader)
    delayShowLoader = setTimeout(() => this._showLoader, 1500)

    if (pop) {
      $body[0].style.height = `${Math.max($oldRegion[0].offsetHeight, this.maxDocHeight)}px`
      $oldRegion.hide() // Can't easily avoid scroll jumps during anime :-(
      pageRequest()
    }
    else {
      // NOTE: `.page` element MUST have a background colour to avoid glitches
      // when changing from static/relative to fixed/absolute position
      // UPDATE: still getting glitches with fixed positioning and scrollTop
      $oldRegion[0].className = pageOutClasses
      $oldRegion.css('transformOrigin', `50% ${st + $(window).height()/2}px`)
      anime({
        duration: pageDuration,
        easing: pageEasing,
        targets: $oldRegion[0],
        scale: .94,
        opacity: 0,
        complete: pageRequest
      })
    }
  }

  _showPage(result, pop, url, title) {
    const that = this
    const $result = $(result)
    const newContent = $(`#${this.$ajaxContainer.attr('id')} .page`, $result).contents()
    const newTitle = title || $result.filter('title').text()
    const $newRegion = $(`<div class="page active bg-black ${pageInClasses}"/>`).append(newContent)
    const $oldRegion = this.$ajaxContainer.find('.page')
    const st = window.pageYOffset || document.documentElement.scrollTop
    const stNew = pop ? st : 0

    this._req = null

    if (!pop) {
      history.pushState({ url: ""+url+"" }, newTitle, url)
    }

    this._hideLoader(false)

    this.$ajaxContainer.append($newRegion)

    this._VHChromeFix()

    this.maxDocHeight = Math.max($newRegion[0].scrollHeight, this.maxDocHeight)
    $body[0].style.height = `${this.maxDocHeight}px`

    function complete() {
      $newRegion.removeClass(pageInClasses)
      $oldRegion.remove()
      that.$ajaxContainer.removeClass('overflow-hidden')
      if (pop) window.scrollTo(0, stNew) // document.documentElement.scrollTop doesn't work in Safari
      $body[0].style.height = null
      document.title = newTitle // Is this necessary? $('<textarea/>').html(newTitle).text()
      that.state.loading = false
      that._onPageShown($newRegion)
    }

    if (pop) {
      $newRegion[0].scrollTop = stNew
      this._beforePageShow($newRegion) // TODO: trigger when stuff is visible?
      $newRegion.show().removeClass('hidden') // Can't easily avoid rendering glitches when using anime :-(
      complete()
    }
    else {
      window.scrollTo(0, stNew) // document.documentElement.scrollTop doesn't work in Safari
      anime({
        duration: pageDuration,
        easing: pageEasing,
        targets: $newRegion[0],
        opacity: [0, 1],
        begin: () => {
          $newRegion.addClass('in').removeClass('hidden')
          this._beforePageShow($newRegion) // TODO: trigger when stuff is visible?
        },
        complete: complete
      })
    }
  }


  /* ==========================================================================
     Reload all scripts after AJAX load
     ========================================================================== */

   // Init all immediately visible stuff before page
   // is visible (i.e. loader has faded out)
  _beforePageShow($page) {
    // Add classes to all ajax links
    this._ajaxLinkClass()
    $html.removeClass('loading')
    $body.toggleClass('inverse', $page.find('.jumbotron:first').data('inverse') === true)
    // Toggle the color of the navbar based on the jumbotron
    // navAffix.toggleInverse($page.find('.jumbotron:first'))
    // When images are loaded
    const lazy = $page[0].querySelectorAll('.lazy');
    if (lazy === null) return
    Array.from(lazy).forEach(img => {
      img.addEventListener('load', () => $(img).closest('figure, .video').addClass('loaded'))
    })

    $page.find('.current-year').text(currentYear);

    this._initEmailForm($page)
  }

   // Do stuff on page load
   // TODO: consider scope for this function - i.e.
   // would some elements outside of the ajax content
   // get initialized twice?
  _onPageShown($page) {
    // Highlight active menu item
    this._highlightMenuItem()
    // Init custom input labels
    $page.find('.input-with-label').each((i, el) => this._toggleInputValue(el))
    // Enable video lightbox + hover effects
    this._initVideoItems($page)
    // Re-enable navbar affix
    // navAffix.enable()
    // Reset focus
    if (document.activeElement) document.activeElement.blur()
  }

  /* ==========================================================================
     Form input behaviour
     ========================================================================== */

  _toggleInputValue(input) {
    $(input).toggleClass('has-value', $(input).val().length > 0)
  }
}

// Netlify authentication for CMS
if (window.netlifyIdentity) {
  window.netlifyIdentity.on("init", user => {
    if (!user) {
      window.netlifyIdentity.on("login", () => {
        document.location.href = "/admin/";
      });
    }
  });
}

window.app = new App({ ajaxContainer: '#ajax-container' }).init()



// WEBPACK FOOTER //
// src/js/app.js